import React, { useEffect, useState } from "react";
import DataGrid from "../common/DataGrid";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Sidebar from "../common/Sidebar";
import {
  firstPage,
  getMapCandiadates,
  gotoPage,
  lastPage,
  loadlocationWithMapListings,
  loadMasterDatas,
  nextPage,
  previousPage,
  setPageSize,
  updateSort,
} from "./action";
import "./index.css";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import locationWithMapFilter from "./locationWithMap";
import { createHeaders, createPageData } from "./locationWithMapUtilities";
import { locationWithMapSelector } from "./selector";

import CandidateMap from "../common/Maps/candidateMap";
import DisplayModal from "../common/Modal/displayModal";

export default () => {
  const navigate = useNavigate();
  const [openGps, setOpenGps] = useState({
    show: false,
    jobData: undefined,
  });
  const headers = createHeaders();
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const { data, pageSize, page, locationMapCandidateList } = useSelector(
    locationWithMapSelector
  );

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();

  const [latlang, setLatlang] = useState({});
  const [candidatelist, setCandidatelist] = useState([]);

  const empId = login.employerUniqueId;
  const employerUniqueId = login.employerUniqueId;
  const url = config.baseUrl;

  useEffect(() => {
    if (config.baseUrl) {
      dispatch(loadMasterDatas(config.baseUrl, empId)).then(() => {
        dispatch(loadlocationWithMapListings({ url, empId }));
        setLatitude(data.approxLatitude);
        setLongitude(data.approxLongitude);
      });
    }
  }, [config]);

  const gotoFirstPage = () => {
    dispatch(firstPage()).then(() => {
      dispatch(loadlocationWithMapListings());
    });
  };
  const gotoNextPage = () => {
    dispatch(nextPage()).then(() => {
      dispatch(loadlocationWithMapListings({ url, empId }));
    });
  };
  const gotoPreviousPage = () => {
    dispatch(previousPage()).then(() => {
      dispatch(loadlocationWithMapListings({ url, empId }));
    });
  };
  const gotoLastPage = () => {
    dispatch(lastPage()).then(() => {
      dispatch(loadlocationWithMapListings({ url, empId }));
    });
  };
  const gotoSelectedPage = (page) => {
    dispatch(gotoPage(page)).then(() => {
      dispatch(loadlocationWithMapListings({ url, empId }));
    });
  };
  const updatePageSize = (size) => {
    dispatch(setPageSize(size)).then(() => {
      dispatch(loadlocationWithMapListings({ url, empId }));
    });
  };

  const showMap2 = (lat, lang, locationid) => {
    setLatlang({ lat, lang });
    getCandidateDetails(lat, lang, locationid);
    setShowModal2(!showModal2);
  };

  const getCandidateDetails = (lat, lang, locationid) => {
    if (lat && lang && locationid) {
      const val = {
        locationId: locationid,
        latitude: lat,
        longitude: lang,
      };
      dispatch(
        getMapCandiadates({
          url: `${config.baseUrl}/Locations/location-map-candidates`,
          val: val,
        })
      );
    }
  };

  const closeMap2 = (event) => {
    event.preventDefault();
    setShowModal2(!showModal2);
  };
  const setLatLng = (e) => {
    if (e.latLng.lat() && e.latLng.lng()) {
      setLatitude(e.latLng.lat());
      setLongitude(e.latLng.lng());
    }
  };

  const generateRowData = (data, headers) => {
    const rowData = {};
    headers.forEach((header) => {
      if (header.type === "text") {
        if (typeof header.field === "array") {
          rowData[header.name] = header.field.map((fld) => data[fld]).join(" ");
        } else {
          rowData[header.name] = data[header.field];
        }
      } else {
        if (header.name === "Map") {
          rowData[header.name] = {
            type: "icon",
            class: `fa fa-map-pin fa-lg green-color-icon`,
            onClick: () => {
              showMap2(
                data.approxLatitude,
                data.approxLongitude,
                data.locationId
              );
            },
          };
        }
      }
    });
    return rowData;
  };
  const formatTableData = (data) => {
    const tableData = {
      headers,
      rows: data?.locations?.map((data) => ({
        columns: generateRowData(data, headers),
      })),
      options: {
        sortable: false,
        filter: false,
        pagination: true,
        pageSize: pageSize || 10,
      },
      pageData: createPageData(page, pageSize, data?.totalPages),
      totalCount: data?.totalPages,
      currentPage: page,
      pageSize,
      firstPage: gotoFirstPage,
      nextPage: gotoNextPage,
      previousPage: gotoPreviousPage,
      lastPage: gotoLastPage,
      updatePageSize: updatePageSize,
      gotoPage: gotoSelectedPage,
      headerComponentParams: {
        sort: (order, column) => {
          dispatch(updateSort(order, column)).then(() => {
            dispatch(loadlocationWithMapListings({ url, empId }));
          });
        },
        headers,
      },
    };
    return tableData;
  };

  return (
    <div className="page main-margin">
      <Loader />
      <Header />
      <Sidebar />
      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">Maps</h1>
                {showModal2 && (
                  <DisplayModal showHide={closeMap2} label={"Candidate Map"}>
                    {latlang.lat &&
                      latlang.lang &&
                      locationMapCandidateList && (
                        <CandidateMap
                          googleMapURL={config.mapURL}
                          containerElement={<div style={{ height: "590px" }} />}
                          mapElement={<div style={{ height: "100%" }} />}
                          loadingElement={<div style={{ height: `100%` }} />}
                          lat={latlang.lat}
                          lng={latlang.lang}
                          locationMapCandidateList={locationMapCandidateList}
                        />
                      )}
                  </DisplayModal>
                )}
              </div>

              <div className="row">
                <div className="col-xl-12 col-md-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <DataGrid {...formatTableData(data)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
